import { PLAN_MANAGEMENT_V2 } from '../../../../paths'

export const PLAN_BENEFIT_OVERRIDES = `/${PLAN_MANAGEMENT_V2}/overrides/plan-benefits`

export const planBenefitOverridesPath = (subtab?: string) =>
  subtab
    ? `${PLAN_BENEFIT_OVERRIDES}/${subtab.toLowerCase()}`
    : `${PLAN_BENEFIT_OVERRIDES}/inactive`
